export type NewOfferActionType =
  | {|
      type: 'INIT_NEW_OFFER',
      payload: {|
        initialOffer: ?Object,
        noNavigation?: boolean,
      |},
    |}
  | {|
      type: 'SET_NEW_OFFER',
      payload: {|
        offer: Object,
      |},
    |}
  | {|
      type: 'INIT_STATE_WITH_OFFER',
      payload: {|
        initialOffer: ?Object,
      |},
    |}
  | {|
      type: 'ADD_OPTION_TO_NEW_OFFER',
      newOption?: Object,
      optionToRemove?: Object,
    |}
  | {|
      type: 'REMOVE_UNAVAILABLE_OFFER',
      availableOption: Object[],
    |};

export const initNewOffer = (initialOffer, noNavigation): NewOfferActionType => ({
  type: 'INIT_NEW_OFFER',
  payload: {
    initialOffer,
    noNavigation,
  },
});

export const setNewOffer = (offer: Object): NewOfferActionType => ({
  type: 'SET_NEW_OFFER',
  payload: {
    offer,
  },
});

export const initStateWithOffer = (initialOffer: ?Object): NewOfferActionType => ({
  type: 'INIT_STATE_WITH_OFFER',
  payload: {
    initialOffer,
  },
});

export const resetOfferState = (): Object =>
  initStateWithOffer({
    plan: {},
    options: [],
  });

export const addOptionToNewOffer = (newOption?: Object, optionToRemove?: Object): NewOfferActionType => {
  return {
    type: 'ADD_OPTION_TO_NEW_OFFER',
    newOption,
    optionToRemove,
  };
};

export const validateSelectedOptions = (availableOption: Object[]): NewOfferActionType => {
  return {
    type: 'REMOVE_UNAVAILABLE_OFFER',
    availableOption,
  };
};
